export var DriveType;
(function (DriveType) {
    DriveType[DriveType["CutwiseDrive"] = 1] = "CutwiseDrive";
    DriveType[DriveType["DmDrive"] = 2] = "DmDrive";
    DriveType[DriveType["CutwiseSpectrum"] = 3] = "CutwiseSpectrum";
    DriveType[DriveType["CutwiseProjects"] = 4] = "CutwiseProjects";
})(DriveType || (DriveType = {}));
